export default __webpack_public_path__ + "static/twitter-8e65601e69067aadfe551b6635ea3420.png";